import { CustomToolbar } from 'admin/toolbars/CustomToolbar';
import { SERVICE_AREA_TYPES } from 'admin/userRelations/userRelationUtils';
import { AuthContext } from 'common/providers/AuthContextProvider/AuthContextProvider';
import { SortDirection, useServiceLocationsQuery } from 'generated/graphql';
import { useContext } from 'react';
import { CheckboxGroupInput, Edit, RecordContext, SimpleForm, TextInput } from 'react-admin';

export const StaffEdit: React.FC = () => {
  const { isAuthenticated } = useContext(AuthContext);

  const { data: serviceLocations } = useServiceLocationsQuery({
    skip: !isAuthenticated,
    variables: {
      sortInput: {
        by: [{ direction: SortDirection.Asc, fieldPath: 'name' }],
      },
    },
  });

  const recordToInput = (record: { serviceLocations: [{ id: string }] }) => ({
    ...record,
    serviceLocationIds: record?.serviceLocations?.map((serviceLocation: { id: string }) => serviceLocation.id),
  });

  return (
    <Edit mutationMode="pessimistic">
      <RecordContext.Consumer>
        {(record) => {
          const input = recordToInput(record as { serviceLocations: [{ id: string }] });
          return (
            <SimpleForm record={input} toolbar={<CustomToolbar />}>
              <TextInput disabled={true} label="Meno" source="user.name" sx={{ width: '40em' }} />
              <TextInput disabled={true} label="Priezvisko" source="user.surname" sx={{ width: '40em' }} />
              <TextInput disabled={true} label="E-mail" required source="user.email" sx={{ width: '40em' }} />
              <TextInput disabled={true} label="Tel." source="user.phoneNumber" sx={{ width: '40em' }} />
              <TextInput disabled={true} label="Externé ID" source="user.externalId" sx={{ width: '40em' }} />
              <CheckboxGroupInput
                choices={serviceLocations?.serviceLocations.items ?? []}
                label="Mestá pôsobenia"
                source="serviceLocationIds"
              />
              <CheckboxGroupInput choices={SERVICE_AREA_TYPES} label="Licencie" source="serviceAreas" />
            </SimpleForm>
          );
        }}
      </RecordContext.Consumer>
    </Edit>
  );
};
